import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';

export function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await api.login({ email, password });
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.message || 'Credenziali non valide');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex bg-gray-50">
            <div className="hidden lg:flex w-1/2 bg-indigo-600 items-center justify-center p-12">
                <div className="text-white max-w-md">
                    <h1 className="text-4xl font-bold mb-4">Tascio Budget</h1>
                    <p className="text-indigo-100 text-lg">
                        Tieni sotto controllo entrate e spese in modo semplice e minimal.
                    </p>
                </div>
            </div>
            <div className="flex-1 flex items-center justify-center p-8">
                <div className="w-full max-w-sm">
                    <div className="mb-8 text-center lg:text-left">
                        <h2 className="text-2xl font-bold text-gray-900">Bentornato</h2>
                        <p className="text-gray-500 text-sm mt-1">Accedi al tuo account Tascio</p>
                    </div>
                    {error && (
                        <div className="mb-4 p-3 text-sm text-red-700 bg-red-50 rounded-lg">{error}</div>
                    )}
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-medium transition disabled:opacity-60"
                        >
                            {loading ? 'Accesso...' : 'Accedi'}
                        </button>
                    </form>
                    <p className="mt-6 text-center text-sm text-gray-500">
                        Non hai un account?{' '}
                        <Link to="/register" className="text-indigo-600 hover:underline">
                            Registrati
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
